import type { RouteLocationRaw, RouteRecordRaw } from "vue-router";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";

export function getResetPasswordFormRouteRecord():RouteRecordRaw{
  return {
    name: 'reset_password_form',
    path: '/reset-password-form',
    component: customAsyncComponent(async () => import('./views/ResetPasswordFormView.vue')),
    meta: {
      noAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.RESET_PASSWORD,
        LOCALE_CATEGORIES.ERRORS,
      ]
    },
  }
}

export function getResetPasswordFormRouteLocation(token: string):RouteLocationRaw{
  return { name: 'reset_password_form', query: { token } }
}